import { ApiGroupRequest } from '@ibe/api';
import { RefObject } from 'react';

export const MAX_NUMBER_OF_ADULTS = 500;
export const MAX_NUMBER_OF_CHILDREN = 500;
export const MIN_NUMBER_OF_SUPPORTED_PARTICIPANTS = 10;
export const ADD_DAYS_TO_START = 2;
export const ADD_DAYS_TO_END = 3;

export interface TravelersPickerProps {
  numberOfAdults: number;
  numberOfChildren: number;
  id?: string;
  tempNumberOfAdults: number;
  setTempNumberOfAdults: (tempNumberOfAdults: number) => void;
  portalRef: RefObject<HTMLDivElement | null>;
  tempNumberOfChildren: number;
  setTempNumberOfChildren: (tempNumberOfChildren: number) => void;
  setNotEnoughParticipantsError: (notEnoughParticipantsError: boolean) => void;
  setNumberOfAdults: (numberOfAdults: number) => void;
  setNumberOfChildren: (numberOfAdults: number) => void;
}

interface Props {
  onSendAction: (groupRequest: ApiGroupRequest) => void;
  onCancelAction: () => void;
  id?: string;

  maxDateRangeSpan?: number;
  startingDate?: string;
  endingDate?: string;
  dateFormat?: string;
}

export default Props;
